import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../../actions/common'
import ProductionList from '../ProductionList'

class ProductionSearchAndList extends Component {
  constructor() {
    super()
    this.fetchProductionData = this.fetchProductionData.bind(this)

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Active productions');
    this.fetchProductionData();
  }

  fetchProductionData() {
    let url = 'productions/active';

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });
      this.setState({
        items: data
      })
    })
  }

  render() {
    return (
      <div>
        <ProductionList
          items={this.state.items}
          filterable={[{
            column: 'Status',
            filters: [
              {
                value: 'active',
                label: 'Active'
              },
              {
                value: 'draft',
                label: 'Draft'
              }
            ]
          }]}
          searchable={[
            'ProjectNumber',
            'OriginalTitle',
            'TypeAndFormat',
            'ClientName'
          ]}
          selectedFilter={'active'}
          />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ProductionSearchAndList))
